import { useState } from 'react';
import { InfoIcon } from './Icons';

/**
 * A footnote tucked behind an icon.
 *
 * For the line you need once and then never again. Left as visible grey text it
 * competes with the figure it belongs to, and across a row of cards those lines
 * wrap to different lengths and leave the row ragged.
 *
 * Hover opens it on a desktop; a touch screen has no hover, so a tap toggles it
 * and it stays until the next tap. Same split as `StackedBars` makes.
 */
export function InfoTip({
  tekst,
  uitlijning = 'rechts',
}: {
  tekst: string;
  /** Which edge the panel hangs from, so it grows away from the screen edge. */
  uitlijning?: 'links' | 'rechts';
}) {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-flex', flex: 'none' }}>
      <button
        type="button"
        aria-label={`Toelichting: ${tekst}`}
        aria-expanded={open}
        onPointerEnter={(e) => {
          if (e.pointerType === 'mouse') setOpen(true);
        }}
        onPointerLeave={(e) => {
          if (e.pointerType === 'mouse') setOpen(false);
        }}
        // Alleen tikken schakelt. Met een muis doet zweven het werk al, en dan
        // zou een klik hem juist dichtklappen terwijl de wijzer erop staat.
        onPointerDown={(e) => {
          if (e.pointerType !== 'mouse') setOpen((v) => !v);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 2,
          border: 'none',
          background: 'none',
          color: open ? '#2A6085' : '#BDB3A5',
          cursor: 'pointer',
          lineHeight: 0,
          transition: 'color .15s ease',
        }}
      >
        <InfoIcon size={14} />
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            ...(uitlijning === 'rechts' ? { right: 0 } : { left: 0 }),
            zIndex: 20,
            width: 214,
            background: '#111111',
            color: '#FFFFFF',
            fontSize: 11.5,
            fontWeight: 400,
            lineHeight: 1.55,
            padding: '8px 10px',
            borderRadius: 4,
            boxShadow: '0 4px 14px rgba(17,17,17,0.22)',
            textAlign: 'left',
            textTransform: 'none',
            letterSpacing: 0,
          }}
        >
          {tekst}
        </span>
      )}
    </span>
  );
}
